module.exports = __webpack_public_path__ + "img/banktransfer1.210403f2.png";